import { useState } from "react";
import { ChevronDown } from "lucide-react";

const GameFooter = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex justify-center items-center p-1">
      <div className="w-full p-">
        <div className="bg-gray-900 text-white rounded-md shadow-md">
          <div
            className="flex justify-between items-center cursor-pointer p-3"
            onClick={() => setIsOpen(!isOpen)}
          >
            <h2 className="font-semibold text-[14px]">Popular Online Games in GUGOBET</h2>
            <ChevronDown
              className={`transform transition-transform duration-300 ${
                isOpen ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
          {isOpen && (
            <div className="mt-3 text-gray-300 text-sm grid grid-cols-4 gap-6 p-3">
              <div>
                <h3 className="font-semibold text-white">Sports</h3>
                <ul className="mt-2 space-y-1">
                  {[
                    "Sports Betting", "Cricket", "Football", "Tennis", "Basketball",
                    "Badminton", "Baseball", "Darts", "Esports", "Golf", "Pool",
                    "Table Tennis", "Volleyball", "Game Rules"
                  ].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">Cricket</h3>
                <ul className="mt-2 space-y-1">
                  {[
                    "IPL Online Betting", "IPL Betting App", "IPL Schedule",
                    "Cricket Today Match", "Live Cricket Betting", "Cricket Betting Odds",
                    "Cricket Betting Tips", "T20 World Cup", "ICC Champions Trophy"
                  ].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">Casino</h3>
                <ul className="mt-2 space-y-1">
                  {[
                    "Live Casino", "Andar Bahar", "Online Roulette", "Teen Patti",
                    "Rummy", "Dragon Tiger", "Baccarat", "Blackjack", "Poker Card",
                    "Table Games", "Slots", "Fish Game", "Arcade Game", "Lucky 7"
                  ].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">Mini Games</h3>
                <ul className="mt-2 space-y-1">
                  {["Aviator games", "JetX", "Keno"].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <h3 className="font-semibold text-white mt-4">Lottery</h3>
                <ul className="mt-2 space-y-1">
                  {["Matka Lottery", "Kerala Lottery", "Pick Lottery"].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">GUGOBET</h3>
                <ul className="mt-2 space-y-1">
                  {["Mobile App", "Registration", "Deposit", "Withdrawal"].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">More Info</h3>
                <ul className="mt-2 space-y-1">
                  {["Promotions", "Partners", "Blog", "FAQ"].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-white">Terms & Conditions</h3>
                <ul className="mt-2 space-y-1">
                  {["Terms of Service", "Privacy Policy", "Account & Payment", "Deposit & Withdraw"].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameFooter;
